/** A vertical menu: white items, the selected one yellow between two spinning diamonds (04 §7). */

import { textWidth } from '../../render/font';
import { BLUE, LIGHT_BLUE } from '../../render/palette';
import type { Screen } from '../../render/screen';
import type { ListLayout, MenuItem } from './menuModel';
import { rowRect } from './menuModel';
import { drawSpinner } from './spinner';
import { FAINT, INK, SELECTED } from './theme';

export interface MenuLook extends ListLayout {
  /** Centre of the labels. */
  readonly cx: number;
  /** Fill each row's hit area with black first (menus over a busy background). */
  readonly plate?: boolean;
  /** Slide items in from the side over the first moments after `ms` 0. */
  readonly slide?: boolean;
  /** A C64 cursor bar behind the selected item. */
  readonly bar?: boolean;
}

/** How far item `i` is still sliding in at `ms` (pixels). Pure. */
export function slideOffset(i: number, ms: number): number {
  const t = ms - i * 28;
  if (t >= 200) return 0;
  if (t <= 0) return 40;
  const p = t / 200;
  return Math.round(40 * (1 - p) * (1 - p));
}

export function drawMenu(screen: Screen, items: readonly MenuItem[], sel: number, look: MenuLook, ms: number): void {
  items.forEach((item, i) => {
    const r = rowRect(look, i);
    if (look.plate === true) screen.fill(r.x, r.y, r.w, r.h, 0);
    const y = look.top + i * look.rowH;
    const dx = look.slide === true ? (i % 2 === 0 ? -1 : 1) * slideOffset(i, ms) : 0;
    const on = i === sel;
    if (on && look.bar === true && dx === 0) {
      screen.fill(r.x + 4, r.y, r.w - 8, r.h, BLUE);
      screen.fill(r.x + 4, r.y, r.w - 8, 1, LIGHT_BLUE);
    }
    const colour = item.disabled === true ? FAINT : on ? SELECTED : INK;
    screen.text(item.label, look.cx + dx, y, colour, 'center');
    if (on && dx === 0) {
      const half = Math.ceil(textWidth(item.label) / 2);
      drawSpinner(screen, look.cx - half - 14, y, ms);
      drawSpinner(screen, look.cx + half + 6, y, ms + 550);
    }
  });
}
